import { useCallback, useContext, useEffect, useState } from 'react';
import useUser from '../../api/hooks/useUser';
import MainContext from '../../context/MainContext';
import useIsMobile from '../../hooks/useIsMobile';
import { CategoryItem, User } from '../../interfaces';
import { getRandomBgColor } from '../../utils/others';
import UserCard from './UserCard';
import useCategory from '../../api/hooks/useCategory';
import useToggle from '../../hooks/useToggle';
import { toIcons } from '../../consts/Paths';
import { useForm } from 'react-hook-form';
import DeleteModal from '../modals/DeleteModal';
import Loader from '../Loader';
import CustomModal from '../modals/CustomModal';
import CustomInput from '../inputs/CustomInput';

const Categories = (props: any) => {
    const { isMobile } = useIsMobile();

    const { isToggled } = props.resetList;

    const { user, userTreated } = useContext(MainContext);

    const { RESPONSES, RESULTS, CTAs } = useCategory();

    const [categories, setCategories] = useState<CategoryItem[]>([]);

    const [edit, setEdit] = useState<boolean>(false);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [item, setItem] = useState({ name: '', id: 0 });

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    const onSubmit = (data: any) => {
        /* console.log("calling: create new user form"); */
        setIsLoading(true);
        CTAs.updateCategory(data.id, data.name);
    };

    const openEdit = (data: any) => {
        setItem(data);
        setEdit(true);
    };

    useEffect(() => {
        reset(); // Reset the form when the modal is closed
    }, [edit, item]);

    const handelOnDeleteClick = useCallback(
        (id: number) => {
            // CTAs.deleteCategory(id);
        },
        [CTAs.deleteCategory]
    );

    useEffect(() => {
        CTAs.getCategory();
    }, [isToggled, user, userTreated, RESPONSES.deleteCategoriesResponse,RESPONSES.updateCategoriesResponse]);

    useEffect(() => {
        /* console.log(registerResponse, registerResult); */
        if (RESPONSES.updateCategoriesResponse?.ok) {
            setIsLoading(false);
            setEdit(false);
        } else if (RESPONSES.updateCategoriesResponse?.ok === false) {
            setIsLoading(false);
        }
    }, [RESPONSES.updateCategoriesResponse]);

    useEffect(() => {
        /* console.log(RESPONSES.getUsersListResponse, RESULTS.getUsersListResult); */
        if (RESPONSES.getCategoriesResponse?.ok) {
            setCategories(
                RESULTS.getCategoriesResult.map((item: any) => ({
                    id: item.id,
                    name: item.name,
                }))
            );
        }
    }, [RESPONSES.getCategoriesResponse,RESPONSES.updateCategoriesResponse]);

    const renderCategories = categories.map((category, key) => {
        return (
            <div key={key} className='user-card' onClick={()=>openEdit(category)}>
                <p style={{ fontFamily: 'Roboto' }}>{category.name}</p>
                <button style={{ width: 50, marginLeft: 10, height: 20, paddingTop: 5, borderRadius: 14 }} className='add-button' onClick={() => openEdit(category)}>
                                            <p style={{ fontSize: 12, margin: 0 }} className='add-buttonText'>
                                                Edit
                                            </p>
                                        </button>
                <img
                    style={{
                        cursor: 'pointer',
                        marginLeft: 'auto',
                        marginRight: isMobile ? '' : '20px',
                    }}
                    src={`${toIcons}/close.svg`}
                    onClick={() => handelOnDeleteClick(category.id)}
                />
            </div>
        );
    });

    return (
          
        <div
            className='users-table shadow'
            style={{
                width: isMobile ? '345px' : '',
                margin: isMobile ? '35px 16px' : '',
            }}
        >
              {edit && (
                <CustomModal setShow={setEdit} title='Modifica' description=''>
                    <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
                        <CustomInput
                            title={'Nome'}
                            name={'name'}
                            type={'text'}
                            register={register}
                            errors={errors}
                            width={'100%'}
                            reset={reset}
                            noIcon={true}
                            defaultValue={item.name}
                            constraints={{
                                required: true,
                            }}
                        />
                        <input type='text' value={item.id} hidden {...register('id')} />
                        {isLoading ? (
                            <Loader />
                        ) : (
                            <button style={{ width: 70, marginTop: 20 }} className='add-button' type='submit'>
                                <p className='add-buttonText'>Salva</p>
                            </button>
                        )}
                    </form>
                </CustomModal>
            )}
            <div
                className='user-table-header'
                style={{
                    justifyContent: isMobile ? 'space-between' : '',
                    margin: '31px 25px',
                }}
            >
                <div className='user-table-header-title-box'>
                    <p className='user-table-header-title'>Categories</p>
                    <p className='user-table-header-description'>Manage categories</p>
                </div>
                <button className='user-table-header-button shadow' type='button' onClick={props.toggler.toggle}>
                    <p className='user-table-header-button-text'>Add category</p>
                </button>
            </div>
            <div className='user-table-content'>
                <div className='offers-table'>
                    <div className='offers-table-fields'>
                        <div
                            style={{
                                margin: isMobile ? '0' : '',
                            }}
                        >
                            <p className='field-label'>Name</p>
                        </div>

                        {!isMobile && (
                            <div className='u-mail'>
                                <p className='field-label'></p>
                            </div>
                        )}
                        <div
                            className='u-status'
                            style={{
                                marginLeft: isMobile ? '135px' : '',
                            }}
                        >
                            <p className='field-label'></p>
                        </div>
                    </div>
                    <div className='divider' style={{ width: '100%', marginTop: '10px' }} />
                    {categories.length > 0 ? <div className='users-table-results scroll-y'>{renderCategories}</div> : <Loader />}
                </div>
            </div>
        </div>
    );
};
export default Categories;
